import React from "react";

const NoticeIcon = ({ width, height, fill, style, onClick }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 23 23"
      fill="none"
      style={style}
      onClick={onClick}
    >
      <path
        d="M11.4503 14.4827C10.7792 14.4827 10.2454 14.9555 10.2454 15.6114C10.2454 16.2672 10.7792 16.7705 11.4503 16.7705C12.1367 16.7705 12.6552 16.2672 12.6552 15.6114C12.6552 14.9555 12.1367 14.4827 11.4503 14.4827ZM12.4265 6.06358L10.459 6.06358L10.459 13.5828L12.4265 13.171L12.4265 6.06358Z"
        fill={fill}
      />
      <circle
        cx="11.5"
        cy="11.5"
        r="10.3162"
        stroke={fill}
        strokeWidth="2.36765"
      />
    </svg>
  );
};

NoticeIcon.defaultProps = {
  width: 23,
  height: 23,
  fill: "white",
};

export default NoticeIcon;
